import { getSpecificClientConfig, constants } from 'redux/modules/client-config/selectors';
import { useSelector } from 'react-redux';

const useCarriersLite = () => {
  const carrierLite = useSelector((store) =>
    getSpecificClientConfig(store, constants.CARRIER_LITE)
  );
  return {
    isCategoryDisabled: carrierLite,
    isScoreDisabled: carrierLite,
    isPODEmailDisabled: carrierLite,
    isCarrierTypeDisabled: carrierLite,
    isOdooDisabled: carrierLite,
    isEditCarrierDisabled: false,
    isEditCarrierLite: carrierLite,
    isEditDriverDisabled: false,
    isAddDriverLite: carrierLite,
    isEditVehicleDisabled: false,
    isAddVehicleLite: carrierLite,
    isDriverChatDisabled: carrierLite,
    isVehicleWidthHidden: carrierLite,
    isContractSectionDisabled: carrierLite,
    isDocumentSectionDisabled: carrierLite,
    isUuidSectionDisabled: carrierLite,
  };
};

export default useCarriersLite;
